import { Component,  EventEmitter,  Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Program, Setup } from 'globals/store/programs.data';
import { HHMMToJustTime, JustTime, justTimeToHHMM, minutesToHHMM } from 'globals/helpers/helpers';
import { timeHelper } from '../../services/helpers/time.helper';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { CommonModule } from '@angular/common';
import { IncrementorComponent } from 'src/app/components/misc/incrementor.component';

@Component({
    selector: 'setup-time',
    template: `
<h5 class="time-title">{{ title }}</h5>
<div class="row" style="margin-top: 10px;">
  <h5>DAY:</h5>
  <incrementor 
    [value]="setup[dayProp] || 0"
    [program]="program"
    [readOnly]="readOnly"
    (onSave)="setup[dayProp] = $event; onSave.emit()"
  ></incrementor>
</div>
<div class="row">
  <h5>TIME:</h5>
  <joi-input *ngIf="!!initialized" [(model)]="timeString" (joiChange)="saveTime()" [disabled]="readOnly" class="start_time on-grey" [autoSelect]="true" [placeholder]="'00:00'" [maxlength]="7"></joi-input>
</div>
`,
    styles: [`
  incrementor { min-height: 25px; }
  ::ng-deep joi-hm-input joi-input { margin: 0px !important; }
  :host ::ng-deep joi-input .oneLine { width: fit-content !important; }
  joi-input { margin: 0px !important; }
  .row { display: flex; align-items: center; }
  .row h5 { margin: auto 10px auto 0; min-width: 30px; }
`],
    standalone: true,
    imports: [JoiInputComponent, CommonModule, IncrementorComponent]
})
export class SetupTimeComponent implements OnChanges {
  @Input() title = 'Access time'
  @Input() setup: Setup
  @Input() program: Program
  @Input() readOnly: boolean
  @Input() dayProp: keyof Pick<Setup, 'accessDay' | 'clearDay'>
  @Input() timeProp: keyof Pick<Setup, 'access' | 'clear'>
  timeString: string
  initialized = false

  @Output() onSave: EventEmitter<void> = new EventEmitter()

  ngOnChanges(changes: SimpleChanges) {
    if (!this.setup) return
    const justTime = this.setup[this.timeProp]
    this.setTimeString(justTime)
  }

  saveTime() {
    // same process as in updateSessionTimesInPlace...
    const minutes = timeHelper.getMinutes(this.timeString)
    const timeString = timeHelper.getTwentyFour(minutes)
    const justTime = HHMMToJustTime(timeString)
    console.log({ justTime, timeString: this.timeString })
    this.setup[this.timeProp] = justTime
    this.onSave.emit()
  }

  setTimeString(justTime: JustTime) {
    this.timeString = justTimeToHHMM(justTime)
    this.initialized = true
  }


}

